module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/AttentionBar-40db267bfa5143472d7bc2bc5ca62d33.png";